import * as ActionUtility from '@utilities/action-utility'
import { getCurrentAcceptanceTermsEffect, getVerifyCompanyEffect, getCategoryEffect } from './company-step-effects'

const REQUEST_SET_EXISTS_COMPANY = 'Aberto.Onboarding.REQUEST_SET_EXISTS_COMPANY'
const REQUEST_SET_EXISTS_COMPANY_FINISHED = 'Aberto.Onboarding.REQUEST_SET_EXISTS_COMPANY_FINISHED'

const REQUEST_GET_CATEGORIES = 'Aberto.Onboarding.REQUEST_GET_CATEGORIES'
const REQUEST_GET_CATEGORIES_FINISHED = 'Aberto.Onboarding.REQUEST_GET_CATEGORIES_FINISHED'

const REQUEST_GET_CURRENT_ACCEPTANCE_TERMS = 'Aberto.Onboarding.REQUEST_GET_CURRENT_ACCEPTANCE_TERMS'
const REQUEST_GET_CURRENT_ACCEPTANCE_TERMS_FINISHED = 'Aberto.Onboarding.REQUEST_GET_CURRENT_ACCEPTANCE_TERMS_FINISHED'

const SET_COMPANY_FIELD = 'Aberto.Onboarding.SET_COMPANY_FIELD'

const verifyCompany = (companyId, partnerId) => {
  return async dispatch => {
    await ActionUtility.createThunkEffect(dispatch, REQUEST_SET_EXISTS_COMPANY, getVerifyCompanyEffect, { companyId, partnerId })
  }
}

const getCategories = () => {
  return async dispatch => {
    await ActionUtility.createThunkEffect(dispatch, REQUEST_GET_CATEGORIES, getCategoryEffect)
  }
}

const getCurrentAcceptanceTerms = () => {
  return async dispatch => {
    await ActionUtility.createThunkEffect(dispatch, REQUEST_GET_CURRENT_ACCEPTANCE_TERMS, getCurrentAcceptanceTermsEffect)
  }
}

const setCompanyField = (name, value) => {
  return ActionUtility.createAction(SET_COMPANY_FIELD, { name, value })
}

export {
  setCompanyField,
  SET_COMPANY_FIELD,
  verifyCompany,
  REQUEST_SET_EXISTS_COMPANY,
  REQUEST_SET_EXISTS_COMPANY_FINISHED,
  getCategories,
  REQUEST_GET_CATEGORIES,
  REQUEST_GET_CATEGORIES_FINISHED,
  getCurrentAcceptanceTerms,
  REQUEST_GET_CURRENT_ACCEPTANCE_TERMS,
  REQUEST_GET_CURRENT_ACCEPTANCE_TERMS_FINISHED,
}
